/*A Save button component*/
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

/** @component
 * Creates a themed save button
 * @param onClick
 * @param visibility
 * @returns {React.Element}
 * @constructor
 */
export const SubmitButton = ({ onClick, disabled }) => {
    return (
        <Button
            variant={disabled ? 'minorOutlined' : 'minorContained'}
            onClick={onClick}
            disabled={disabled}
            sx={{ height: 40 }}
            data-analyticsid='submit-button'
        >
            Submit
        </Button>
    );
};

SubmitButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};
